
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { LinkedinIconSVG } from './linkedin-icon.svg';

@Component({
  selector: 'crm-common-association-card-content',
  templateUrl: './common-association-card-content.component.html',
  styleUrls: ['./common-association-card-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconModule],
})
export class CommonAssociationCardContentComponent {
  @Input() iconName = '';
  @Input() isSvgIcon?: boolean;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
  ) {
    this.matIconRegistry.addSvgIconLiteral('linkedin', this.sanitizer.bypassSecurityTrustHtml(LinkedinIconSVG));
  }
}
